import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUserInfoSuccessfully } from "../redux/actions/login.actions";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Box, Button, TextField, Typography } from "@mui/material";
// eslint-disable-next-line no-unused-vars -- Intended for togglePasswordVisibility
import "./Style.css";
const envVariable = require("../EnvironmentVariables.json");
import { reconnectNotifications } from "../utils/ws/useNotificationListener";
import { ACTIVE_LOGIN_TITLE, LOGIN_SUBTITLE } from "../branding";

function Home() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = {
      email: username,
      password: password,
      user_type: "SCO",
    };

    fetch(envVariable.serverId + "/SCO/login.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.type === "success") {
          if (data.message) {
            localStorage.setItem("@api_key", data.message);
            localStorage.setItem("api_key", data.message); // optional alias
          }
          localStorage.setItem("isAuthenticated", true);
          localStorage.setItem("User_Id", data.id);
          localStorage.setItem("SC_Id", data.sc_id);
          localStorage.setItem("sc_name", data.sc_name);
          localStorage.setItem("api_key", data.message); // Store API key
          // Store a minimal userinfo payload for Redux (optional)
          dispatch(setUserInfoSuccessfully({ id: data.id, sc_id: data.sc_id, sc_name: data.sc_name }));
          // Ensure WebSocket notifications connect immediately post-login
          try { reconnectNotifications(); }
          catch (e) { console.debug('reconnectNotifications failed', e); }
          navigate("/account");
        } else if (data.status === "Pending") {
          setError("Your account approval is pending. Please wait for approval before logging in.");
        } else {
          setError("Invalid username or password. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setError("An error occurred. Please try again later.");
      });
  };

  // eslint-disable-next-line no-unused-vars -- Looks like this was planned but not completed
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <Navbar />
      <Box display="flex" flexDirection="column" alignItems="center" className="login-container">
        <Box className="login-box" padding={4} borderRadius={2} boxShadow={3} maxWidth={400} width="100%">
          <Box className="login-brand-heading">
            <Typography component="h1" className="login-brand-title-primary">
              {ACTIVE_LOGIN_TITLE.primary}
            </Typography>
            <Typography component="h2" className="login-brand-title-secondary">
              {ACTIVE_LOGIN_TITLE.secondary}
            </Typography>
          </Box>
          <Typography variant="body2" color="textSecondary">
            {LOGIN_SUBTITLE}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mt: 0.5 }}>
            No account? <Link to="/register">Sign up</Link>
          </Typography>
          <form onSubmit={handleSubmit} className="form-style">
            <input type="text" style={{ display: "none" }} autoComplete="username" />

            <TextField
              label="Username or email address"
              variant="outlined"
              fullWidth
              margin="normal"
              autoComplete="new-username"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Box display="flex" alignItems="center" marginTop={2}>
              <TextField
                label="Password"
                variant="outlined"
                fullWidth
                type={showPassword ? "text" : "password"}
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Box>
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ marginTop: 3 }}>
              Sign in
            </Button>
          </form>
          {error && (
            <Typography color="error" mt={2}>
              {error}
            </Typography>
          )}
        </Box>
      </Box>
      <Footer pastLogin={false} />
    </>
  );
}

export default Home;
